import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { ProiectePushNotificationsService } from '../proiecte-push-notifications.service';
import { environment } from 'src/environments/environment';
import { StorageService } from 'src/app/services/storage.service';
import { finalize, map } from 'rxjs';
import { ProiectePushNotification } from '../proiecte-push-notifications.interface';
import { helper } from 'src/environments/helper';
import { AppFilesService } from 'src/app/services/app-files.service';
import { AddImageComponent } from './add-image/add-image.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ViewImageComponent } from './view-image/view-image.component';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-view-push-notification',
    templateUrl: './view-push-notification.component.html',
    styleUrls: ['./view-push-notification.component.scss']
})
export class ViewPushNotificationComponent implements OnInit {
    token!: string;
    isLoading = false;
    user: any = null;
    pushNotification!: ProiectePushNotification | null;
    passedRequestId!: number;

    helper = helper;

    imageUrls: { [key: number]: string } = {};

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<ViewPushNotificationComponent>,
        private authService: AuthService,
        private proiectePushNotificationsService: ProiectePushNotificationsService,
        private storageService: StorageService,
        private appFilesService: AppFilesService,
        private breakpointObserver: BreakpointObserver,
    ) {
        this.processToken();
        this.passedRequestId = this.data.pushNotification.id_push;
    }

    ngOnInit(): void {
        this.getRequestInfo();

    }

    getRequestInfo() {
        this.isLoading = true;
        this.proiectePushNotificationsService
            .getPushNotificationById(this.passedRequestId)
            .pipe(map((response: any) => response.data))
            .subscribe((requestData) => {
                this.isLoading = false;
                this.pushNotification = requestData;
                this.loadImages();
            })
    }

    processUserDetails() {
        const userObj = this.storageService.getObject(environment.config.userKey);
        userObj
            .then((val) => {
                this.user = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token: string) => {
            this.token = token;
            this.proiectePushNotificationsService.setToken(token);
            this.processUserDetails();
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    openAddDialog() {
        let configData = {
            data: this.passedRequestId,
            disableClose: true,
            width: '60%',
            height: 'auto',
            minWidth: '275px',
        }

        const dialogRef = this.dialog.open(AddImageComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 599px)', // xs breakpoint
            '(min-width: 600px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 599px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', 'auto')
                } else {
                    // Larger devices
                    dialogRef.updateSize('40%', 'auto')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }

            layoutChangeSubscription.unsubscribe()
        })
    }

    getImages(id: number) {
        this.isLoading = true;
        this.proiectePushNotificationsService.getImage(id)
            .subscribe({
                next: (imageBlob: Blob) => {
                    const imageUrl = URL.createObjectURL(imageBlob);
                    this.imageUrls[id] = imageUrl;
                    this.isLoading = false;
                },
                error: (error) => {
                    this.isLoading = false;
                    console.error('Error fetching image:', error);
                }
            });
    }

    loadImages() {
        this.pushNotification?.gallery_list.forEach((image: any) => {
            this.getImages(image.id);
        });
    }

    openViewDialog(imageUrl: string) {
        let configData = {
            data: { imageUrl },
            disableClose: true,
            width: '60%',
            height: 'auto',
            minWidth: '275px',
        }

        const dialogRef = this.dialog.open(ViewImageComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 599px)', // xs breakpoint
            '(min-width: 600px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 599px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', 'auto')
                } else {
                    // Larger devices
                    dialogRef.updateSize('40%', 'auto')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }

            layoutChangeSubscription.unsubscribe()
        })
    }

    deleteImage(id: number) {
        Swal.fire({
            title: 'Sunteți sigur?',
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Confirm!',
            cancelButtonText: 'Anulare',
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.proiectePushNotificationsService
                    .deleteImage(id)
                    .subscribe({
                        next: () => {
                            Swal.fire({
                                title: 'Șters!',
                                text: 'Imagine ștearsă cu succes.',
                                icon: 'success',
                                confirmButtonText: 'OK',
                            }).then(() => {
                                this.getRequestInfo();
                            });
                        },
                        error: (err: any) => {
                            Swal.fire({
                                title: helper.dialogConfig.headers.errorAtentie,
                                text: err.error.errors.message[0],
                                icon: 'error',
                                confirmButtonText: helper.dialogConfig.buttonLabels.close,
                            })
                        }
                    })
            }
        });
    }
}